import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../component/button/Button";

interface ModalConfirmationProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const ModalConfirmation: React.FC<ModalConfirmationProps> = ({ show, onHide, onConfirm }) => {
  return (
    <Modal show={show} onHide={onHide} centered className="p-3">
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Selecting this option will delete the tax file number you have entered. Are you sure you want to continue?</p>
      </Modal.Body>
      
      <Modal.Footer className="p-3">
        <div className="text-end">
            <Button clasName="btn save-close-button" onClick={onHide} label={"No"} />
            <Button clasName="btn btn-primary ms-3" onClick={onConfirm} label={
                    <>
                      <div className="d-flex">
                        <div className="yes-save-div">
                          <i className="pi pi-check"></i>
                        </div>
                        <span className="ms-2">Yes</span>
                      </div>
                    </>
                  } />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmation;